import Bowser from 'bowser';

export const initBrowserCompatability = function () {
  const browser = Bowser.getParser(window.navigator.userAgent).getBrowserName();
  // Edge / IE compatibility for TinySlider
  if (browser === 'Microsoft Edge' || browser === 'Internet Explorer') {
    const tinySliderContainer = document.getElementsByClassName('popular-pages__slide-container');

    if (tinySliderContainer !== null && tinySliderContainer.length > 0) {
      for (const container of tinySliderContainer) {
        container.classList.add('--ms-compat');
      }
    }
  }
};
